import './style/Arena.css';
import algebraImg from '../images/algebra.png';
import advancedMathImg from '../images/advanced-math.png';
import geometryAndTrigonometryImg from '../images/geometry-and-trigonometry.png';
import problemSolvingAndDataAnalysisImg from '../images/problem-solving-and-data-analysis.png';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { authFetch } from '../authFetch';

function Arena (props) {
    const navigate = useNavigate();
    const [algebraRatingBoxes, setAlgebraRatingBoxes] = useState(['', '', '', '', '', '', '']);
    const [advancedMathRatingBoxes, setAdvancedMathRatingBoxes] = useState(['', '', '', '', '', '', '']);
    const [geometryAndTrigonometryRatingBoxes, setGeometryAndTrigonometryRatingBoxes] = useState(['', '', '', '', '', '', '']);
    const [problemSolvingAndDataAnalysisRatingBoxes, setProblemSolvingAndDataAnalysisRatingBoxes] = useState(['', '', '', '', '', '', '']);
    const [algebraRating, setAlgebraRating] = useState(null);
    const [advancedMathRating, setAdvancedMathRating] = useState(null);
    const [geometryAndTrigonometryRating, setGeometryAndTrigonometryRating] = useState(null);
    const [problemSolvingAndDataAnalysisRating, setProblemSolvingAndDataAnalysisRating] = useState(null);
    const [ratingsLoading, setRatingsLoading] = useState(true);
    const [algebraQuestionsAnswered, setAlgebraQuestionsAnswered] = useState(null);
    const [advancedMathQuestionsAnswered, setAdvancedMathQuestionsAnswered] = useState(null);
    const [geometryAndTrigonometryQuestionsAnswered, setGeometryAndTrigonometryQuestionsAnswered] = useState(null);
    const [problemSolvingAndDataAnalysisQuestionsAnswered, setProblemSolvingAndDataAnalysisQuestionsAnswered] = useState(null);

    const onClickOption = (option) => {
        navigate(`/arena/${option}`);
    }

    const loadRatings = async () => {
        try {
            const response = await authFetch(`${process.env.REACT_APP_API_BASE}/arena/loadRatings`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            const data = await response.json();
            if (data.success) {
                setAlgebraRating(data.algebraRating);
                setAdvancedMathRating(data.advancedMathRating);
                setGeometryAndTrigonometryRating(data.geometryAndTrigonometryRating);
                setProblemSolvingAndDataAnalysisRating(data.problemSolvingAndDataAnalysisRating);
            }
            else {console.log('error');}
        } 
        catch (error) {
            console.error('Error:', error);
        }
    };

    const loadQuestionsAnswered = async () => {
        try {
            const response = await authFetch(`${process.env.REACT_APP_API_BASE}/arena/loadQuestionsAnswered`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            const data = await response.json();
            if (data.success) {
                setAlgebraQuestionsAnswered(data.algebraQuestionsAnswered);
                setAdvancedMathQuestionsAnswered(data.advancedMathQuestionsAnswered);
                setGeometryAndTrigonometryQuestionsAnswered(data.geometryAndTrigonometryQuestionsAnswered);
                setProblemSolvingAndDataAnalysisQuestionsAnswered(data.problemSolvingAndDataAnalysisQuestionsAnswered);
            }
            else {console.log('error');}
        } 
        catch (error) {
            console.error('Error:', error);
        }
    };

    const updateRatingBoxes = (rating) => {
        const boxes = ['', '', '', '', '', '', ''];
        if (rating >= 200) {boxes[0] = 'filled';}
        if (rating >= 370) {boxes[1] = 'filled';}
        if (rating >= 420) {boxes[2] = 'filled';}
        if (rating >= 470) {boxes[3] = 'filled';}
        if (rating >= 550) {boxes[4] = 'filled';}
        if (rating >= 610) {boxes[5] = 'filled';}
        if (rating >= 680) {boxes[6] = 'filled';}
        return boxes;
    };

    useEffect(() => {
        if (!props.user) return;
        const loadAll = async () => {
            setRatingsLoading(true);
            await Promise.all([
                loadRatings(),
                loadQuestionsAnswered()
            ]);
            setRatingsLoading(false);
        };
        loadAll();
    }, []);

    useEffect(() => {
        setAlgebraRatingBoxes(updateRatingBoxes(algebraRating));
        setAdvancedMathRatingBoxes(updateRatingBoxes(advancedMathRating));
        setGeometryAndTrigonometryRatingBoxes(updateRatingBoxes(geometryAndTrigonometryRating));
        setProblemSolvingAndDataAnalysisRatingBoxes(updateRatingBoxes(problemSolvingAndDataAnalysisRating));
    }, [algebraRating, advancedMathRating, geometryAndTrigonometryRating, problemSolvingAndDataAnalysisRating]);

    return (
        <div className="arena-container">
            {ratingsLoading ? (
                <>
                    <div className='card skeleton-card'><div className='shimmer'></div></div>
                    <div className='card skeleton-card'><div className='shimmer'></div></div>
                    <div className='card skeleton-card'><div className='shimmer'></div></div>
                    <div className='card skeleton-card'><div className='shimmer'></div></div>
                </>
            ) : (
                <>
            <div className='card' id="algebra">
                <div className='card-title'>
                    <p>Algebra</p>
                </div>
                <span className='info-icon'>i</span>
                <div className='img-section'>
                    <img src={algebraImg} alt="Algebra" onClick={() => onClickOption('algebra')}/>
                    <div className='info-text'>
                        <ul>
                            <li>Linear equations in one variable</li>
                            <li>Linear functions</li>
                            <li>Linear equations in two variables</li>
                            <li>Systems of two linear equations in two variables</li>
                            <li>Linear inequalities in one or two variables</li>
                        </ul>
                    </div>
                </div>
                <div className='rating-display'>
                    <p>{algebraRating}</p>
                    <div className='rating-bar'>
                        {algebraRatingBoxes.map((box, index) => (
                            <div key={index} className={box}></div>
                        ))}
                    </div>
                    <p className='questions-answered'>Questions Answered: {algebraQuestionsAnswered}</p>
                </div>
            </div>
            <div className='card'>
                <div className='card-title'>
                    <p>Advanced Math</p>
                </div>
                <span className='info-icon'>i</span>
                <div className='img-section'>
                    <img src={advancedMathImg} alt="Advanced Math" onClick={() => onClickOption('advanced-math')}/>
                    <div className='info-text'>
                        <ul>
                            <li>Nonlinear functions</li>
                            <li>Nonlinear equations in one variable</li>
                            <li>Systems of equations in two variables</li>
                            <li>Equivalent expressions</li>
                        </ul>
                    </div>
                </div>
                <div className='rating-display'>
                    <p>{advancedMathRating}</p>
                    <div className='rating-bar'>
                        {advancedMathRatingBoxes.map((box, index) => (
                            <div key={index} className={box}></div>
                        ))}
                    </div>
                    <p className='questions-answered'>Questions Answered: {advancedMathQuestionsAnswered}</p>
                </div>
            </div>
            <div className='card'>
                <div className='card-title'>
                    <p>Problem-Solving</p>
                    <p className='separator'>&</p>
                    <p>Data Analysis</p>
                </div>
                <span className='info-icon'>i</span>
                <div className='img-section'>
                    <img src={problemSolvingAndDataAnalysisImg} alt="Problem-Solving and Data Analysis" onClick={() => onClickOption('problem-solving-and-data-analysis')}/>
                    <div className='info-text'>
                        <ul>
                            <li>Ratios, rates, proportional relationships, and units</li>
                            <li>Percentages</li>
                            <li>One-variable data: Distributions and measures of center and spread</li>
                            <li>Two-variable data: Models and scatterplots</li>
                            <li>Probability and conditional probability</li>
                            <li>Inference from sample statistics and margin of error</li>
                            <li>Evaluating statistical claims: Observational studies and experiments</li>
                        </ul>
                    </div>
                </div>
                <div className='rating-display'>
                    <p>{problemSolvingAndDataAnalysisRating}</p>
                    <div className='rating-bar'>
                        {problemSolvingAndDataAnalysisRatingBoxes.map((box, index) => (
                            <div key={index} className={box}></div>
                        ))}
                    </div>
                    <p className='questions-answered'>Questions Answered: {problemSolvingAndDataAnalysisQuestionsAnswered}</p>
                </div>
            </div>
            <div className='card'>
                <div className='card-title'>
                    <p>Geometry</p>
                    <p className='separator'>&</p>
                    <p>Trigonometry</p>
                </div>
                <span className='info-icon'>i</span>
                <div className='img-section'>
                    <img src={geometryAndTrigonometryImg} alt="Geometry and Trigonometry" onClick={() => onClickOption('geometry-and-trigonometry')}/>
                    <div className='info-text'>
                        <ul>
                            <li>Area and volume</li>
                            <li>Lines, angles, and triangles</li>
                            <li>Right triangles and trigonometry</li>
                            <li>Circles</li>
                        </ul>
                    </div>
                </div>
                <div className='rating-display'>
                    <p>{geometryAndTrigonometryRating}</p>
                    <div className='rating-bar'>
                        {geometryAndTrigonometryRatingBoxes.map((box, index) => (
                            <div key={index} className={box}></div>
                        ))}
                    </div>
                    <p className='questions-answered'>Questions Answered: {geometryAndTrigonometryQuestionsAnswered}</p>
                </div>
            </div>
                </>
            )}
        </div>
    )
}

export default Arena;